import { useState } from 'react';

type SetFunctionType<ObjectType> = <T extends keyof ObjectType>(
  name: T,
  value: ObjectType[T]
) => void;

const useObjectState = <ObjectType>(
  defaultState: ObjectType
): [ObjectType, SetFunctionType<ObjectType>] => {
  const [state, setState] = useState<ObjectType>(defaultState);

  const onChange: SetFunctionType<ObjectType> = (name, value) => {
    setState(prev => ({ ...prev, [name]: value }));
  };

  return [state, onChange];
};

class Wrapper<T extends unknown> {
  mediate = (rest: any) => useObjectState<T>(rest);
}

export type UseObjectStateReturnType<T extends unknown> = ReturnType<Wrapper<T>['mediate']>;

export default useObjectState;
